/* eslint-disable @typescript-eslint/no-explicit-any */
import {
 Controller,
 FieldValues,
 FieldErrors,
 //  Control,
} from 'react-hook-form'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {ErrorMessage} from '@hookform/error-message'
import {KTSVG} from 'helpers'
import {KTText} from '../KTText'

interface Props {
 label?: string
 required?: boolean
 id?: string
 name: string
 disabled?: boolean
 autoComplete?: string
 errorText?: string
 errorKey?: string
 placeholder?: string
 autofocus?: boolean
 rules?: FieldValues
 value?: string
 control: any
 dateFormat: string
 defaultValue?: Date
 minDate?: Date | undefined
 maxDate?: Date | undefined
 className?: string
 popperClassName?: string
 wrapperClassName?: string
 inputWrapperClassName?: string
 calendarIconClassName?: string
 labelClassName?: string
 errorIconClassName?: string
 iconPath?: string
 showIcon?: boolean
 helperTextClass?: string
 helperText?: string
 errors?: FieldErrors | undefined
}

const DatePickerField = (props: Props) => {
 const {
  label,
  className,
  showIcon = false,
  wrapperClassName,
  iconPath,
  labelClassName,
  errorIconClassName,
  popperClassName,
  calendarIconClassName,
  name,
  required,
  id,
  defaultValue,
  disabled,
  autoComplete = 'off',
  autofocus,
  rules,
  placeholder,
  control,
  dateFormat,
  minDate,
  maxDate,
  helperTextClass,
  inputWrapperClassName,
  helperText,
  errors,
 } = props

 return (
  <div className={`${wrapperClassName}`}>
   <div
    className={`${inputWrapperClassName} ${
     disabled && '!bg-[#F5F8FA]'
    } form-field-wrapper py-2 px-4 relative rounded-lg border border-solid border-[#E6EBF0] bg-white focus-within:border-[#000000]`}
   >
    {label && (
     <label
      htmlFor={id}
      className={`input-label ${labelClassName} relative pb-1 text-[#4E83E4] text-xs font-medium`}
     >
      {label}
      {required && (
       <span className='required-field pl-[2px]'>*</span>
      )}
     </label>
    )}
    {/* <FontAwesomeIcon icon={faCalendar} className="fas fa-plus font-normal absolute text-[#808080] right-4 !z-[2] !focus:z-[2] top-3" ></FontAwesomeIcon> */}
    <Controller
     control={control}
     rules={rules}
     name={name}
     render={({field}) => {
      const {onChange, onBlur, value, name, ref} = field
      return (
       <DatePicker
        ref={ref}
        toggleCalendarOnIconClick
        selected={value ? value : defaultValue}
        wrapperClassName={`w-full`}
        className={`form-input ${className} !disabled:bg-blue-300 relative text-[#80868C] pr-6 text-lg font-normal block w-full ${
         errors?.[name] && 'border-[#CC293F]'
        }`}
        popperClassName={`${popperClassName} !z-[2]`}
        portalId='root-portal'
        showIcon={true}
        icon='fa fa-calendar'
        calendarIconClassName={`${calendarIconClassName} z-[1] pt-[10px] right-0`}
        id={id ?? name}
        onChange={onChange}
        onBlur={onBlur}
        placeholderText={placeholder}
        disabled={disabled}
        value={value}
        autoComplete={autoComplete}
        autoFocus={autofocus}
        required={required}
        name={name}
        minDate={minDate}
        maxDate={maxDate}
        dateFormat={dateFormat}
        showMonthDropdown={true}
        showYearDropdown={true}
        yearDropdownItemNumber={100}
        scrollableYearDropdown
       />
      )
     }}
    />

    {(errors?.[name] ?? showIcon) && (
     <KTSVG
      path={`${iconPath ?? '/media/icons/icon_error.svg'}`}
      svgClassName={`${errorIconClassName} absolute bottom-[10px] z-11 right-[10px]`}
     />
    )}
   </div>
   {helperText && !errors?.[name] && (
    <KTText className={helperTextClass}>
     {helperText}
    </KTText>
   )}
   {errors && (
    <ErrorMessage
     errors={errors}
     name={name}
     render={({message}) => (
      <p className='error-msg error-cls'>{message}</p>
     )}
    />
   )}
  </div>
 )
}

export {DatePickerField}
